import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { Transition } from 'react-transition-group';
import { fg } from '@atlaskit/platform-feature-flags';
const duration = {
  enter: 0,
  exit: 100
};
/**
 * __Fade__
 *
 * A fade in animation used for spotlights.
 *
 * @internal
 */
export const Fade = ({
  hasEntered,
  children,
  onExited
}) => {
  const nodeRef = React.useRef(null);
  return /*#__PURE__*/React.createElement(Transition, _extends({
    in: hasEntered,
    timeout: duration,
    onExited: onExited,
    unmountOnExit: true,
    appear: true
  }, fg('platform-design-system-dsp-20687-transition-group') && {
    nodeRef
  }), status => {
    const base = {
      transition: `opacity ${duration.exit}ms`,
      opacity: 0
    };
    const anim = {
      entered: {
        opacity: 1
      },
      exiting: {
        opacity: 0
      }
    };
    const style = {
      ...base,
      ...anim[status]
    };
    return children(style);
  });
};